module.exports = __webpack_public_path__ + "static/media/deadpool1.fed7a265.jpg";